import React, { useCallback, useRef, useState } from 'react'
import { debounce } from 'lodash'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { useResizeObserver } from 'hooks/useResizeObserver'
import { AUTO_ATTR_KEY, AutomationId } from 'utils/automationUtil'
import LinkedAuthor from './LinkedAuthor'
import { AuthorHandleStyles } from '../index.css'

const StyledRedditSouce = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.subreddit
})`
  ${AuthorHandleStyles}
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
  border-left: 1px solid ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
  margin-left: 1px;
  padding-left: 5px;
`

type RedditAuthorColumnProps = {
  name: string
  sourceName: string
  url: string
}

const RedditAuthorColumn = ({ name, sourceName, url }: RedditAuthorColumnProps) => {
  const theme = useDisplayTheme() as Theme
  const [displayTooltip, setDisplayTooltip] = useState(false)
  const cellContentRef = useRef<HTMLDivElement>(null)

  const checkCellContent = () => {
    if (!cellContentRef.current) return
    const cellContent = cellContentRef.current

    if (!displayTooltip) {
      setDisplayTooltip(cellContent?.scrollHeight > cellContent?.clientHeight)
    }
  }

  useResizeObserver(
    cellContentRef,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useCallback(debounce(checkCellContent, 10), [])
  )

  return (
    <>
      <LinkedAuthor url={url} name={name} />
      <StyledRedditSouce mode={theme} ref={cellContentRef as React.RefObject<HTMLDivElement>}>
        <Tooltip mode={theme} enabled={displayTooltip} content={sourceName}>
          <span>{sourceName}</span>
        </Tooltip>
      </StyledRedditSouce>
    </>
  )
}

export default RedditAuthorColumn
